import React from 'react'
import { Box } from '@workwhile/ui'
import { ChargesHeader } from './ChargesHeader'
import { ChargesFilters } from './ChargesFilters'
import { ChargesList } from './ChargesList'

export const ChargesMain = () => {
  return (
    <>
      <ChargesHeader />
      <Box margin={3}>
        <ChargesFilters />
        <ChargesList />
      </Box>
    </>
  )
}
